import React from 'react';
import CountryHomePage from '../countrymainpages/CountryHomePage';

const Uae = () => {
  return <CountryHomePage countryCode="uae" />;
};

export default Uae;